<template>
  <div>
    <div v-if="!ordreTravail.otPatrimoine">
      <div class="card mgt-20px">
        <div class="card-content has-text-centered pd-40px">
          <h1 class="title is-size-3">
            {{ $t('detailOrdreTravailTech.patrimoine.noPat')}}
          </h1>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="card mgt-20px">
        <div class="card-content">
          <info-emplacement  v-if="ordreTravail.otPatrimoine
          && ordreTravail.otPatrimoine.emplacement"
                             :emplacementTechnique=
                               "ordreTravail.otPatrimoine.emplacementTechnique">
          </info-emplacement>
          <info-dispositif v-if="ordreTravail.otPatrimoine
          && ordreTravail.otPatrimoine.dispositif"
                           :ot-patrimoine-accessoires=
                             "ordreTravail.otPatrimoine.otPatrimoineAccessoires"
                           :dispositif-technique=
                             "ordreTravail.otPatrimoine.dispositifTechnique">
          </info-dispositif>
          <info-materiel v-if="ordreTravail.otPatrimoine
          && ordreTravail.otPatrimoine.materiel"
                         :materielTechnique="ordreTravail.otPatrimoine.materielTechnique">
          </info-materiel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import infoDispositif
  from '@/components/logistique/ordreTravail/tech/detail/patrimoine/infoDispositif';
import infoEmplacement
  from '@/components/logistique/ordreTravail/tech/detail/patrimoine/infoEmplacement';
import infoMateriel from '@/components/logistique/ordreTravail/tech/detail/patrimoine/infoMateriel';

export default {
  name: 'LogistiqueOrdreTravailTechniqueDetailPatrimoine',
  props: {
    ordreTravail: {
      type: Object,
      required: true,
    },
  },
  components: {
    infoDispositif,
    infoEmplacement,
    infoMateriel,
  },
};

</script>
